import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import CommDialog from '@/components/CommDialog'
import Loading from '@/components/Loading'
import ImgPreview from '@/components/ImgPreview'
import dragDialog from "@/directive/el-drag-dialog"

import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/user-center.css';
import 'bootstrap-icons/font/bootstrap-icons.css'

Vue.use(dragDialog)
Vue.use(ElementUI);
Vue.use(Loading)
Vue.use(ImgPreview)
Vue.use(CommDialog)


import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
